import { Switch } from '@mui/material';
import React from "react";

import "./customerEdit.jsx.css";
import { useParams } from "react-router-dom";
import { useGetUserQuery } from "../../services/userCRUDApi";
import {
  House,
  Signpost,
  LocationCity,
  CalendarToday,
  BadgeOutlined,
  LocationSearching,
  MailOutline,
  PhoneAndroid,
  Business,
  CorporateFare,
  Apartment,

} from "@mui/icons-material";
import user_image from "../profile/UserAfatar.jpg";
import { Alert, CircularProgress } from "@mui/material";
import { useUpdateUserMutation } from "../../services/userCRUDApi";
import { useState, useEffect } from "react";

function CustomerEdit() {
  const { id } = useParams();
  const responseData = useGetUserQuery(id);
  const [data, setData] = useState({
    password: "",
    repeat_password: "",
  });
  const [success, setSuccess] = useState(false);
  const [server_error, setServerError] = useState({});
  const [updateUser, { isLoading }] = useUpdateUserMutation();

  useEffect(() => {
    if (responseData.isSuccess) {
      const userData = responseData.data;
      setData((prev) => ({
        ...prev,
        id: userData.id,
        first_Name: userData.first_Name,
        last_Name: userData.last_Name,
        phone_Number: userData.phone_Number,
        data_Joind: userData.data_Joind,
        email: userData.email,
        last_login: userData.last_login,
        type: userData.type,
        company_name: userData.company_name || "",
        company_size: userData.company_size || "",
        Vat_number: userData.Vat_number || "",
        is_active: userData.is_active,
        // Address
        house_Number: userData.address?.house_Number || "",
        street_Number: userData.address?.street_Number || "",
        city: userData.address?.city || "",
        area: userData.address?.area || "",
        // Company Address
        company_city: userData.company_address?.city || "",
        company_area: userData.company_address?.area || "",
        company_street: userData.company_address?.street_Number || "",
        company_postal_code: userData.company_address?.postal_code || "",
      }));
    }
  }, [responseData]);

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setData((values) => ({ ...values, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const actualData = {
      id: data.id,
      first_Name: data.first_Name,
      last_Name: data.last_Name,
      phone_Number: data.phone_Number,
      type: data.type,
      company_name: data.company_name,
      company_size: data.company_size,
      Vat_number: data.Vat_number,
      is_active: data.is_active,
      // Address
      address_Id: responseData.data.address?.address_Id,
      address: {
        house_Number: data.house_Number,
        street_Number: data.street_Number,
        city: data.city,
        area: data.area,
      },
      // Company Address
      company_address: {
        city: data.company_city || "",
        area: data.company_area || "",
        street_Number: data.company_street || "",
        postal_code: data.company_postal_code || "",
      },
      password: data.password,
      repeat_password: data.repeat_password,
    };

    console.log("Submitting data:", actualData); // Debug log

    try {
      const res = await updateUser(actualData);

      if (res.error) {
        console.error("Update error:", res.error);
        if (res.error.data) {
          setServerError(
            res.error.data.errors || { general: res.error.data.message }
          );
        } else {
          setServerError({ general: "Update failed. Please try again." });
        }
      } else if (res.data) {
        console.log("Update success:", res.data);
        setSuccess(true);
        setServerError({});
        setData((prev) => ({ ...prev, password: "", repeat_password: "" }));
      }
    } catch (error) {
      console.error("Unexpected error:", error);
      setServerError({ general: "An unexpected error occurred." });
    }
  };

  return (
    <div className="user">
      <h1 className="userTitle">User Profile</h1>

      {/* Success and Error Messages */}
      {success && (
        <Alert severity="success" sx={{ mb: 2 }}>
          Profile Data Updated Successfully
        </Alert>
      )}

      {server_error.general && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {server_error.general}
        </Alert>
      )}

      {Object.keys(server_error).map(
        (key) =>
          key !== "general" && (
            <Alert key={key} severity="error" sx={{ mb: 2 }}>
              {key}: {server_error[key]}
            </Alert>
          )
      )}

      <div className="userContainer">
        {/* User Show Section */}
        <div className="userShowContainer">
          <div className="userShow">
            <div className="userShowTop">
              <img src={user_image} alt="" className="userShowImg" />
              <div className="userShowTopTitle">
                <span className="userShowUsername">
                  <span className="infoLabel">First Name:</span>
                  <span className="infoValue">{data.first_Name}</span>
                </span>
                <span className="userShowUsername">
                  <span className="infoLabel">Last Name:</span>
                  <span className="infoValue">{data.last_Name}</span>
                </span>
                <span className="userShowUsername">
                  <span className="infoLabel">User Type:</span>
                  <span className="infoValue">{data.type}</span>
                </span>
              </div>
            </div>

            <div className="userShowBottom">
              {/* Personal Details */}
              <span className="userShowTitle">Personal Details</span>
              <div className="userUpdateItem">
  <label>Account Status</label>
  <div style={{display: 'flex', alignItems: 'center'}}>
    <span style={{marginRight: '10px'}}>Inactive</span>
    <Switch
      checked={data.is_active || false}
      onChange={(e) => setData({...data, is_active: e.target.checked})}
      name="is_active"
      color="primary"
    />
    <span style={{marginLeft: '10px'}}>Active</span>
  </div>
</div>
              <div className="userShowInfo">
                <MailOutline className="infoIcon" />
                  <span className="infoLabel">Account Status:</span>
  <span className="infoValue" style={{color: data.is_active ? 'green' : 'red'}}>
    {data.is_active ? 'Active' : 'Inactive'}
  </span>
                <span className="infoLabel">Email:</span>
                <span className="infoValue">{data.email}</span>
              </div>
              <div className="userShowInfo">
                <PhoneAndroid className="infoIcon" />
                <span className="infoLabel">Phone:</span>
                <span className="infoValue">{data.phone_Number}</span>
              </div>
              <div className="userShowInfo">
                <CalendarToday className="infoIcon" />
                <span className="infoLabel">Joined:</span>
                <span className="infoValue">{data.data_Joind}</span>
              </div>
              <div className="userShowInfo">
                <CalendarToday className="infoIcon" />
                <span className="infoLabel">Last Login:</span>
                <span className="infoValue">{data.last_login}</span>
              </div>

              {/* Address Details */}
              <span className="userShowTitle">Address Details</span>
              <div className="userShowInfo">
                <House className="infoIcon" />
                <span className="infoLabel">House Number:</span>
                <span className="infoValue">{data.house_Number}</span>
              </div>
              <div className="userShowInfo">
                <Signpost className="infoIcon" />
                <span className="infoLabel">Street:</span>
                <span className="infoValue">{data.street_Number}</span>
              </div>
              <div className="userShowInfo">
                <LocationSearching className="infoIcon" />
                <span className="infoLabel">Area:</span>
                <span className="infoValue">{data.area}</span>
              </div>
              <div className="userShowInfo">
                <LocationCity className="infoIcon" />
                <span className="infoLabel">City:</span>
                <span className="infoValue">{data.city}</span>
              </div>

              {/* Company Details */}
              <span className="userShowTitle">Company Details</span>
              <div className="userShowInfo">
                <Business className="infoIcon" />
                <span className="infoLabel">Company Name:</span>
                <span className="infoValue">{data.company_name}</span>
              </div>
              <div className="userShowInfo">
                <BadgeOutlined className="infoIcon" />
                <span className="infoLabel">Company Size:</span>
                <span className="infoValue">{data.company_size}</span>
              </div>
              <div className="userShowInfo">
                <BadgeOutlined className="infoIcon" />
                <span className="infoLabel">VAT Number:</span>
                <span className="infoValue">{data.Vat_number}</span>
              </div>

              {/* Company Address Details */}
              <span className="userShowTitle">Company Address</span>
              <div className="userShowInfo">
                <LocationCity className="infoIcon" />
                <span className="infoLabel">Company City:</span>
                <span className="infoValue">{data.company_city}</span>
              </div>
              <div className="userShowInfo">
                <Apartment className="infoIcon" />
                <span className="infoLabel">Company Area:</span>
                <span className="infoValue">{data.company_area}</span>
              </div>
              <div className="userShowInfo">
                <Signpost className="infoIcon" />
                <span className="infoLabel">Company Street:</span>
                <span className="infoValue">{data.company_street}</span>
              </div>
              <div className="userShowInfo">
                <CorporateFare className="infoIcon" />
                <span className="infoLabel">Postal Code:</span>
                <span className="infoValue">{data.company_postal_code}</span>
              </div>
            </div>
          </div>
        </div>

        {/* User Update Section */}
        <div className="userUpdateContainer">
          <div className="userShow">
            <span className="userUpdateTitle">Edit</span>
            <form className="userUpdateForm" onSubmit={handleSubmit}>
              <div className="userUpdateLeft">
                {/* Personal Details Form */}
                <span className="userShowTitle">Personal Details</span>
                <div className="userUpdateItem">
                  <label>First Name</label>
                  <input
                    type="text"
                    name="first_Name"
                    value={data.first_Name || ""}
                    onChange={handleChange}
                    className="userUpdateInput"
                  />
                </div>
                <div className="userUpdateItem">
                  <label>Last Name</label>
                  <input
                    type="text"
                    name="last_Name"
                    value={data.last_Name || ""}
                    onChange={handleChange}
                    className="userUpdateInput"
                  />
                </div>
                <div className="userUpdateItem">
                  <label>Phone Number</label>
                  <input
                    type="text"
                    name="phone_Number"
                    value={data.phone_Number || ""}
                    onChange={handleChange}
                    className="userUpdateInput"
                  />
                </div>

                {/* Address Details Form */}
                <span className="userShowTitle">Address Details</span>
                <div className="userUpdateItem">
                  <label>House Number</label>
                  <input
                    type="text"
                    name="house_Number"
                    value={data.house_Number || ""}
                    onChange={handleChange}
                    className="userUpdateInput"
                  />
                </div>
                <div className="userUpdateItem">
                  <label>Street</label>
                  <input
                    type="text"
                    name="street_Number"
                    value={data.street_Number || ""}
                    onChange={handleChange}
                    className="userUpdateInput"
                  />
                </div>
                <div className="userUpdateItem">
                  <label>Area</label>
                  <input
                    type="text"
                    name="area"
                    value={data.area || ""}
                    onChange={handleChange}
                    className="userUpdateInput"
                  />
                </div>
                <div className="userUpdateItem">
                  <label>City</label>
                  <select
                    className="userUpdateSelect"
                    name="city"
                    value={data.city || ""}
                    onChange={handleChange}
                  >
<option value="">Select City</option>
<option value="Abbottabad">Abbottabad</option>
<option value="Attock">Attock</option>
<option value="Bahawalpur">Bahawalpur</option>
<option value="Burewala">Burewala</option>
<option value="Chakwal">Chakwal</option>
<option value="Chiniot">Chiniot</option>
<option value="Dera Ghazi Khan">Dera Ghazi Khan</option>
<option value="Dera Ismail Khan">Dera Ismail Khan</option>
<option value="Faisalabad">Faisalabad</option>
<option value="Gujranwala">Gujranwala</option>
<option value="Gujrat">Gujrat</option>
<option value="Gwadar">Gwadar</option>
<option value="Hyderabad">Hyderabad</option>
<option value="Islamabad">Islamabad</option>
<option value="Jacobabad">Jacobabad</option>
<option value="Jhang">Jhang</option>
<option value="Jhelum">Jhelum</option>
<option value="Karachi">Karachi</option>
<option value="Kasur">Kasur</option>
<option value="Khairpur">Khairpur</option>
<option value="Khanewal">Khanewal</option>
<option value="Kohat">Kohat</option>
<option value="Lahore">Lahore</option>
<option value="Larkana">Larkana</option>
<option value="Layyah">Layyah</option>
<option value="Mardan">Mardan</option>
<option value="Mianwali">Mianwali</option>
<option value="Mirpur Khas">Mirpur Khas</option>
<option value="Multan">Multan</option>
<option value="Muzaffargarh">Muzaffargarh</option>
<option value="Nawabshah">Nawabshah</option>
<option value="Nowshera">Nowshera</option>
<option value="Okara">Okara</option>
<option value="Pakpattan">Pakpattan</option>
<option value="Peshawar">Peshawar</option>
<option value="Quetta">Quetta</option>
<option value="Rahim Yar Khan">Rahim Yar Khan</option>
<option value="Rawalpindi">Rawalpindi</option>
<option value="Sahiwal">Sahiwal</option>
<option value="Sargodha">Sargodha</option>
<option value="Sheikhupura">Sheikhupura</option>
<option value="Sialkot">Sialkot</option>
<option value="Sukkur">Sukkur</option>
<option value="Swabi">Swabi</option>
<option value="Swat">Swat</option>
<option value="Toba Tek Singh">Toba Tek Singh</option>
<option value="Vehari">Vehari</option>
<option value="Wah Cantt">Wah Cantt</option>
<option value="Zhob">Zhob</option>
                  </select>
                </div>

                {/* Company Details Form */}
                <span className="userShowTitle">Company Details</span>
                <div className="userUpdateItem">
                  <label>Company Name</label>
                  <input
                    type="text"
                    name="company_name"
                    value={data.company_name || ""}
                    onChange={handleChange}
                    className="userUpdateInput"
                  />
                </div>
                <div className="userUpdateItem">
                  <label>Company Size</label>
                  <input
                    type="text"
                    name="company_size"
                    value={data.company_size || ""}
                    onChange={handleChange}
                    className="userUpdateInput"
                  />
                </div>
                <div className="userUpdateItem">
                  <label>VAT Number</label>
                  <input
                    type="text"
                    name="Vat_number"
                    value={data.Vat_number || ""}
                    onChange={handleChange}
                    className="userUpdateInput"
                  />
                </div>

                {/* Company Address Form */}
                <span className="userShowTitle">Company Address</span>
                <div className="userUpdateItem">
                  <label>Company City</label>
                  <select
                    className="userUpdateSelect"
                    name="company_city"
                    value={data.company_city || ""}
                    onChange={handleChange}
                  >
                    <option value="">Select City</option>
<option value="Aberdeen City">Aberdeen City</option>
<option value="Aberdeenshire">Aberdeenshire</option>
<option value="Abertaw GB-ATA">Abertaw GB-ATA</option>
<option value="Angus">Angus</option>
<option value="Antrim">Antrim</option>
<option value="Ards">Ards</option>
<option value="Argyll and Bute">Argyll and Bute</option>
<option value="Armagh">Armagh</option>
<option value="Ballymena">Ballymena</option>
<option value="Ballymoney">Ballymoney</option>
<option value="Banbridge">Banbridge</option>
<option value="Barking and Dagenham">Barking and Dagenham</option>
<option value="Barnet">Barnet</option>
<option value="Barnsley">Barnsley</option>
<option value="Bath and North East Somerset">Bath and North East Somerset</option>
<option value="Bedfordshire">Bedfordshire</option>
<option value="Belfast">Belfast</option>
<option value="Bexley">Bexley</option>
<option value="Birmingham">Birmingham</option>
<option value="Blackburn with Darwen">Blackburn with Darwen</option>
<option value="Blackpool">Blackpool</option>
<option value="Blaenau Gwent">Blaenau Gwent</option>
<option value="Bolton">Bolton</option>
<option value="Borders Region">Borders Region</option>
<option value="Bournemouth">Bournemouth</option>
<option value="Bracknell Forest">Bracknell Forest</option>
<option value="Bradford">Bradford</option>
<option value="Brent">Brent</option>
<option value="Brighton and Hove">Brighton and Hove</option>
<option value="Bristol">Bristol</option>
<option value="Bromley">Bromley</option>
<option value="Bro Morgannwg GB-BMG">Bro Morgannwg GB-BMG</option>
<option value="Buckinghamshire">Buckinghamshire</option>
<option value="Bury">Bury</option>
<option value="Caerdydd GB-CRD">Caerdydd GB-CRD</option>
<option value="Caerffili GB-CAF">Caerffili GB-CAF</option>
<option value="Camden">Camden</option>
<option value="Carrickfergus">Carrickfergus</option>
<option value="Casnewydd GB-CNW">Casnewydd GB-CNW</option>
<option value="Castell-nedd Port Talbot GB-CTL">Castell-nedd Port Talbot GB-CTL</option>
<option value="Castlereagh">Castlereagh</option>
<option value="Cheshire">Cheshire</option>
<option value="Clackmannanshire">Clackmannanshire</option>
<option value="Coleraine">Coleraine</option>
<option value="Conwy">Conwy</option>
<option value="Cookstown">Cookstown</option>
<option value="Cornwall">Cornwall</option>
<option value="Coventry">Coventry</option>
<option value="Craigavon">Craigavon</option>
<option value="Croydon">Croydon</option>
<option value="Cumbria">Cumbria</option>
<option value="Darlington">Darlington</option>
<option value="Derby">Derby</option>
<option value="Derbyshire">Derbyshire</option>
<option value="Derry">Derry</option>
<option value="Devon">Devon</option>
<option value="Doncaster">Doncaster</option>
<option value="Dorset">Dorset</option>
<option value="Down">Down</option>
<option value="Dudley">Dudley</option>
<option value="Dumfries and Galloway">Dumfries and Galloway</option>
<option value="Dundee City">Dundee City</option>
<option value="Dungannon">Dungannon</option>
<option value="Durham">Durham</option>
<option value="Ealing">Ealing</option>
<option value="East Ayrshire">East Ayrshire</option>
<option value="East Dunbartonshire">East Dunbartonshire</option>
<option value="East Lothian">East Lothian</option>
<option value="East Renfrewshire">East Renfrewshire</option>
<option value="East Riding of Yorkshire">East Riding of Yorkshire</option>
<option value="East Sussex">East Sussex</option>
<option value="Edinburg">Edinburg</option>
<option value="Eilean Siar">Eilean Siar</option>
<option value="Enfield">Enfield</option>
<option value="Essex">Essex</option>
<option value="Falkirk">Falkirk</option>
<option value="Farmanagh">Farmanagh</option>
<option value="Fife">Fife</option>
<option value="Gateshead">Gateshead</option>
<option value="Glasgow City">Glasgow City</option>
<option value="Gloucestershire">Gloucestershire</option>
<option value="Greenwich">Greenwich</option>
<option value="Gwynedd">Gwynedd</option>
<option value="Hackney">Hackney</option>
<option value="Halton">Halton</option>
<option value="Hammersmith and Fulham">Hammersmith and Fulham</option>
<option value="Hampshire">Hampshire</option>
<option value="Haringey">Haringey</option>
<option value="Harrow">Harrow</option>
<option value="Hartlepool">Hartlepool</option>
<option value="Havering">Havering</option>
<option value="Herefordshir">Herefordshir</option>
<option value="Hertfordshire">Hertfordshire</option>
<option value="Highland">Highland</option>
<option value="Hillingdon">Hillingdon</option>
<option value="Hounslow">Hounslow</option>
<option value="Inverclyde">Inverclyde</option>
<option value="Isle of Wight">Isle of Wight</option>
<option value="Isles of Scilly">Isles of Scilly</option>
<option value="Islington">Islington</option>
<option value="Kensingaton and Chelsea">Kensingaton and Chelsea</option>
<option value="Kent">Kent</option>
<option value="Kingston upon Hul">Kingston upon Hul</option>
<option value="Kington upon Thame">Kington upon Thame</option>
<option value="Kirkless">Kirkless</option>
<option value="Knowsley">Knowsley</option>
<option value="Lambeth">Lambeth</option>
<option value="Lancashire">Lancashire</option>
<option value="Larne">Larne</option>
<option value="Leeds">Leeds</option>
<option value="Leicester">Leicester</option>
<option value="Leicestershire">Leicestershire</option>
<option value="Lewishem">Lewishem</option>
<option value="Limavady">Limavady</option>
<option value="Lincolnshire">Lincolnshire</option>
<option value="Lisburn">Lisburn</option>
<option value="Liverpool">Liverpool</option>
<option value="London">London</option>
<option value="Luton">Luton</option>
<option value="Magherafelt">Magherafelt</option>
<option value="Manchester">Manchester</option>
<option value="Medway">Medway</option>
<option value="Merthyr Thudful GB-MTU">Merthyr Thudful GB-MTU</option>
<option value="Merton">Merton</option>
<option value="Middlesbrough">Middlesbrough</option>
<option value="Midlothian">Midlothian</option>
<option value="Milton Keynes">Milton Keynes</option>
<option value="Moray">Moray</option>
<option value="Moyle">Moyle</option>
<option value="Newcastle upon Tyne">Newcastle upon Tyne</option>
<option value="Newham">Newham</option>
<option value="Newry and Mourne">Newry and Mourne</option>
<option value="Newtownabbey">Newtownabbey</option>
<option value="Norfolk">Norfolk</option>
<option value="Northamptonshire">Northamptonshire</option>
<option value="North Ayshire">North Ayshire</option>
<option value="North Down">North Down</option>
<option value="North East Lincolnshire">North East Lincolnshire</option>
<option value="North Lanarkshire">North Lanarkshire</option>
<option value="North Lincolnshire">North Lincolnshire</option>
<option value="North Somerset">North Somerset</option>
<option value="North Tyneside">North Tyneside</option>
<option value="Northhumberland">Northhumberland</option>
<option value="North Yorkshire">North Yorkshire</option>
<option value="Nottingham">Nottingham</option>
<option value="Nottinghamshire">Nottinghamshire</option>
<option value="Oldham">Oldham</option>
<option value="Omagh">Omagh</option>
<option value="Orkney Islands">Orkney Islands</option>
<option value="Oxfordshire">Oxfordshire</option>
<option value="Pen-y-bont or Ogwr GB-POG">Pen-y-bont or Ogwr GB-POG</option>
<option value="Perth and Kinross">Perth and Kinross</option>
<option value="Peterborough">Peterborough</option>
<option value="Plymouth">Plymouth</option>
<option value="Poole">Poole</option>
<option value="Portsmouth">Portsmouth</option>
<option value="Powys">Powys</option>
<option value="Reading">Reading</option>
<option value="Redbridge">Redbridge</option>
<option value="Redcar and Cleveland">Redcar and Cleveland</option>
<option value="Renfrewshire">Renfrewshire</option>
<option value="Rhondd">Rhondd</option>
<option value="Richmond upon Thames">Richmond upon Thames</option>
<option value="Rochdale">Rochdale</option>
<option value="Rotherham">Rotherham</option>
<option value="Rutland">Rutland</option>
<option value="Salford">Salford</option>
<option value="Sandwell">Sandwell</option>
<option value="Scottish Border">Scottish Border</option>
<option value="Sefton">Sefton</option>
<option value="Sheffield">Sheffield</option>
<option value="Shetland Islands">Shetland Islands</option>
<option value="Shropshire">Shropshire</option>
<option value="Sir Benfro GB-BNF">Sir Benfro GB-BNF</option>
<option value="Sir Ceredigion">Sir Ceredigion</option>
<option value="Sir Ddinbych GB-DDB">Sir Ddinbych GB-DDB</option>
<option value="Sir Fynwy GB-FYN">Sir Fynwy GB-FYN</option>
<option value="Sir Gaerfyrddin GB-GFY">Sir Gaerfyrddin GB-GFY</option>
<option value="Sir y Fflint GB-FFL">Sir y Fflint GB-FFL</option>
<option value="Sir Ynys Mon GB-YNM">Sir Ynys Mon GB-YNM</option>
<option value="Slough">Slough</option>
<option value="Solihull">Solihull</option>
<option value="Somerset">Somerset</option>
<option value="Southampton">Southampton</option>
<option value="South Ayrshire">South Ayrshire</option>
<option value="Southend-on-Sea">Southend-on-Sea</option>
<option value="South Gloucestershire">South Gloucestershire</option>
<option value="South Lanarkshire">South Lanarkshire</option>
<option value="South Tyneside">South Tyneside</option>
<option value="Southwark">Southwark</option>
<option value="St. Helens">St. Helens</option>
<option value="Staffordshire">Staffordshire</option>
<option value="Stirling">Stirling</option>
<option value="Stockport">Stockport</option>
<option value="Stockton-on-Tees">Stockton-on-Tees</option>
<option value="Stoke-on-Trent">Stoke-on-Trent</option>
<option value="Strabane">Strabane</option>
<option value="Suffolk">Suffolk</option>
<option value="Sunderland">Sunderland</option>
<option value="Surrey">Surrey</option>
<option value="Sutton">Sutton</option>
<option value="Swindon">Swindon</option>
<option value="Tameside">Tameside</option>
<option value="Telford and Wrekin">Telford and Wrekin</option>
<option value="Thurrock">Thurrock</option>
<option value="Tor-faen">Tor-faen</option>
<option value="Torbay">Torbay</option>
<option value="Tower Hamlets">Tower Hamlets</option>
<option value="Trafford">Trafford</option>
<option value="Wakefield">Wakefield</option>
<option value="Walsall">Walsall</option>
<option value="Waltham Forest">Waltham Forest</option>
<option value="Wandsworth">Wandsworth</option>
<option value="Warrington">Warrington</option>
<option value="Warwickshire">Warwickshire</option>
<option value="West Berkshire">West Berkshire</option>
<option value="West Dunbartonshire">West Dunbartonshire</option>
<option value="West Lothian">West Lothian</option>
<option value="Westminster">Westminster</option>
<option value="Wigan">Wigan</option>
<option value="Wiltshire">Wiltshire</option>
<option value="Windsor and Maidenhead">Windsor and Maidenhead</option>
<option value="Wirral">Wirral</option>
<option value="Wokingham">Wokingham</option>
<option value="Wolverhampton">Wolverhampton</option>
<option value="Worcestershire">Worcestershire</option>
<option value="Wrexham">Wrexham</option>
<option value="York">York</option>
                  </select>
                </div>
                <div className="userUpdateItem">
                  <label>Company Area</label>
                  <input
                    type="text"
                    name="company_area"
                    value={data.company_area || ""}
                    onChange={handleChange}
                    className="userUpdateInput"
                  />
                </div>
                <div className="userUpdateItem">
                  <label>Company Street</label>
                  <input
                    type="text"
                    name="company_street"
                    value={data.company_street || ""}
                    onChange={handleChange}
                    className="userUpdateInput"
                  />
                </div>
                <div className="userUpdateItem">
                  <label>Company Postal Code</label>
                  <input
                    type="text"
                    name="company_postal_code"
                    value={data.company_postal_code || ""}
                    onChange={handleChange}
                    className="userUpdateInput"
                  />
                </div>

                {/* Password Update */}
                <span className="userShowTitle">Password</span>
                <div className="userUpdateItem">
                  <label>New Password</label>
                  <input
                    type="password"
                    name="password"
                    value={data.password || ""}
                    onChange={handleChange}
                    className="userUpdateInput"
                    placeholder="Leave blank to keep current"
                  />
                </div>
                <div className="userUpdateItem">
                  <label>Repeat Password</label>
                  <input
                    type="password"
                    name="repeat_password"
                    value={data.repeat_password || ""}
                    onChange={handleChange}
                    className="userUpdateInput"
                    placeholder="Leave blank to keep current"
                  />
                </div>
              </div>

              <div className="userUpdateRight">
                {isLoading ? (
                  <CircularProgress />
                ) : (
                  <button type="submit" className="userUpdateButton">
                    Update
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerEdit;
